import { render, staticRenderFns } from "./touZiList.vue?vue&type=template&id=42db8a00&"
import script from "./touZiList.vue?vue&type=script&lang=js&"
export * from "./touZiList.vue?vue&type=script&lang=js&"
import style0 from "./touZiList.vue?vue&type=style&index=0&id=42db8a00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports